import * as React from "react";
import { Alert, Checkbox, Stack, Text, TextInput } from "@mantine/core";
import { CommunicationType } from "../../data/api/communicationApi";
import { CenteredLoader } from "../common/loader";
import TextSeparator from "../common/TextSeparator";
import { IPersonalSettingsProps } from "./PersonalSettings";

interface INotificationSettingState {
  email?: { [key in CommunicationType]?: boolean };
  browser?: { [key in CommunicationType]?: boolean };
}

export const PersonalNotificationSettings: React.FunctionComponent<
  IPersonalSettingsProps
> = (props) => {
  const [settings, _updateSettings] = React.useState<INotificationSettingState>(
    { ...props.person.notifications },
  );

  const [isLoading, setIsLoading] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);

  const updateSettings = (settings) => {
    setIsLoading(true);
    setError(null);
    _updateSettings(settings);
    props.actions
      .savePerson({ notifications: settings, _id: props.person._id })
      .then((_) => {
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        setError(err.message);
      });
  };

  const emailTypeSettings = CommunicationType.getAllTypes().map((k) => (
    <Checkbox
      key={k}
      label={CommunicationType.toString(k)}
      checked={settings?.email?.[k] ?? false}
      onChange={(e) =>
        updateSettings({
          ...settings,
          email: { ...settings.email, [k]: e.currentTarget.checked },
        })
      }
      styles={{ label: { fontSize: "17px" } }}
    />
  ));

  const browserNotificationSettings = CommunicationType.getAllTypes().map(k => (
    <Checkbox
      key={k}
      label={CommunicationType.toString(k)}
      checked={settings?.browser?.[k] ?? false}
      onChange={(e) =>
        updateSettings({
          ...settings,
          browser: { ...settings.browser, [k]: e.currentTarget.checked },
        })
      }
      styles={{ label: { fontSize: "17px" } }}
    />
  ))

  return (
    <>
      <p>
        Control options for how StadiumSupervisor communicates or notifies you
        of certain events.
      </p>
      {isLoading && <CenteredLoader />}
      {error && (
        <Alert color="red" withCloseButton onClose={() => setError(null)}>
          {error}
        </Alert>
      )}
      <TextSeparator>Email notifications</TextSeparator>
      <Stack gap="sm" style={{ marginLeft: "30px" }}>{emailTypeSettings}</Stack>

      {/* <TextSeparator>Browser notifications</TextSeparator>
      <div style={{ marginLeft: "30px" }}>{browserNotificationSettings}</div> */}
    </>
  );
};
